import React, {useContext} from "react";
import moment from "moment";
import GlobalContext from "../GlobalContext";
import YearNavigator from "./YearNavigator";
import MonthNavigator from "./MonthNavigator";

const Navigator = () => {

  const CONTEXT = useContext(GlobalContext);

  // type - prev/next
  function setDate(setSelectedDay, setSelectedMonth, setSelectedYear, type) {
    let newDate;

    if(type === 'prev') {
      newDate = moment([CONTEXT.selectedYear, CONTEXT.selectedMonth]).subtract(1, 'months');
    }
    if(type === 'next') {
      newDate = moment([CONTEXT.selectedYear, CONTEXT.selectedMonth]).add(1, 'months');
    }
    if (newDate.year() <= CONTEXT.eventsExtremeDates.newest && newDate.year() >= CONTEXT.eventsExtremeDates.oldest) {
        setSelectedDay(1);
        setSelectedMonth(newDate.month());
        setSelectedYear(newDate.year());
    }
  }

  return (
    <div className="navigator row">
      <GlobalContext.Consumer>
        {({
            setSelectedDay,
            setSelectedMonth,
            setSelectedYear
          }) => (
          <>
            <div className="prev col-3 text-right">
              <i onClick={() => setDate(
                setSelectedDay,
                setSelectedMonth,
                setSelectedYear,
              'prev'
              )}
                 className="fas fa-chevron-left cursor-pointer px-1"></i>
            </div>
          <div className="month-name col-6 text-center font-weight-bold">
              {/*<div className="d-inline-block">{CONTEXT.MONTHS_TRANSLATIONS[CONTEXT.selectedMonth]}</div>*/}
              <MonthNavigator/>
              <YearNavigator/>
          </div>
            <div className="next col-3 ">
              <i onClick={() => setDate(
                setSelectedDay,
                setSelectedMonth,
                setSelectedYear,
                'next'
              )}
                 className="fas fa-chevron-right cursor-pointer px-1 float-right"></i>
            </div>
          </>
        )}
      </GlobalContext.Consumer>
    </div>
  );
};

export default Navigator;
